import { render, staticRenderFns } from "./EfsMdDiseaseModal.vue?vue&type=template&id=50243d5a&scoped=true&"
import script from "./EfsMdDiseaseModal.vue?vue&type=script&lang=js&"
export * from "./EfsMdDiseaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50243d5a",
  null
  
)

export default component.exports